// extracted by mini-css-extract-plugin
export default {"TwoDimsFeature":"wa_a bhf_b bhf_wb"};